// 提取通用功能
function getSelectedValues() {
    const elements = document.querySelectorAll(".t4s-dib.t4s-swatch__current");
    if (elements.length === 0) {
        console.log("Cannot find matched elements");
        return null;
    }
    
    return Array.from(elements).map(element => element.textContent.trim()).join(" / ");
}

function handleElementsUpdate() {
    const result = getSelectedValues();
    if (result) {
        // console.log(result);
        updateFiveDescription(result);
    }
}

// 主功能
document.addEventListener("DOMContentLoaded", function () {
    // 初始检查
    handleElementsUpdate();
    
    // 设置观察者
    const observer = new MutationObserver(() => handleElementsUpdate());
    const config = {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
    };
    
    const targetNode = document.querySelector(".t4s-swatch");
    if (targetNode) {
        observer.observe(targetNode, config);
    } else {
        console.log("Cannot find watch target element");
    }
    
    // 移动端查看更多功能
    const fullLists = document.querySelectorAll(".five-point-list");
    const isMobile = window.matchMedia("(max-width: 16880px)").matches;
    
    if (isMobile) {
        fullLists.forEach((fullList) => {
            const seeMoreBtn = fullList.nextElementSibling;
            const items = fullList.querySelectorAll("li");
            
            // 初始状态
            for (let i = 1; i < items.length; i++) {
                items[i].style.display = "none";
            }
            seeMoreBtn.style.display = "block";
            
            // 事件处理
            seeMoreBtn.addEventListener("click", function () {
                const isExpanded = seeMoreBtn.textContent === "See less";
                
                // 切换显示
                for (let i = 2; i < items.length; i++) {
                    items[i].style.display = isExpanded ? "none" : "list-item";
                }
                
                // 更新按钮状态
                seeMoreBtn.textContent = isExpanded ? "See more" : "See less";
                seeMoreBtn.classList.toggle("see-less", !isExpanded);
            });
        });
    }
});

// 更新显示函数
function updateFiveDescription(result) {
    const couponContainers = document.querySelectorAll(".JC-LGL-five-point-container");
    
    couponContainers.forEach(container => {
        container.style.display = "none";
    });
    
    const matchingContainer = document.querySelector(`.JC-LGL-five-point-container[data-variant-title="${result}"]`);
    if (matchingContainer) {
        matchingContainer.style.display = "block";
    } else {
        console.log("Cannot find matching five-point container");
    }
}

// 图片切换功能
function changeImage(imageSrc) {
    const productImage = document.getElementById('productImage');
    if (productImage) {
        productImage.src = imageSrc;
    }
}